import { getRequest } from '../services/requestHandler';
import { LieDigit } from '../models';

//4 for testing
export const getLieDigits = async (headTypeId = null) => {
  const url = headTypeId ? `loft/getLieDigits?headTypeId=${headTypeId}` : 'loft/getLieDigits';
  const response = await getRequest<LieDigit>('GetLieDigits', url);
  return response;
};
